import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import getAxiosInstance from "../api/axiosInstance";

const axiosInstance = getAxiosInstance();

const CheckInOut = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    // Get the data passed from the previous page
    const { userType, selectedUser } = location.state || {};

    useEffect(() => {
        if (!userType || !selectedUser) {
            // Redirect back if no userType or selectedUser is provided
            navigate("/error");
        }
    }, [userType, selectedUser, navigate]);

    const handleAction = async (eventType) => {
        setLoading(true);
        setError(null);

        try {
            const response = await axiosInstance.post("/attendances", {
                user_id: selectedUser.id,
                user_type: userType,
                event_type: eventType,
            });
            if (response.status === 201) {
                navigate("/confirmation", {
                    state: {
                        card: selectedUser,
                        action: eventType,
                        userType,
                        response: response.data,
                    },
                });
            }
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error.message}</div>;
    }

    return (
        <div
            className='flex flex-col items-center justify-center'
            style={{height: "calc(100% - 64px)"}}>
            <div
                className='flex flex-row items-center justify-center gap-16'
                style={{
                    width: "calc(100% - 120px)",
                    "@media (max-width: 1024px)": {
                        width: "calc(100% - 80px)",
                    },
                }}>
                <button onClick={() => handleAction("check_in")} className='button-xl flex-1'>
                    <span>IN</span>
                </button>
                <button onClick={() => handleAction("check_out")} className='button-xl flex-1'>
                    <span>OUT</span>
                </button>
            </div>
        </div>
    )
    ;
};

export default CheckInOut;
